export const ECheqRequestHeaderElements = [
  { label: "Fecha", value: "fechaCreacion", align: "inherit" },
  { label: "Titular Cuenta", value: "titular", align: "inherit" },
  { label: "N° Cuenta", value: "cuenta", align: "inherit" },
  { label: "Monto", value: "monto", align: "inherit" },
  { label: "Solicitante", value: "usuarioCrea", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];
